// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Browser ki memory se token check karo
  const token = localStorage.getItem('adminToken');

  // Agar token hai toh aage jane do (<Outlet />), warna Login pe bhejo (<Navigate />)
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;